// ELements

export const NEW_ELEMENT = (state, newElement) => {
	console.log("MUTATION new el", newElement);
	state.newElement = newElement;
}

export const ADD_ELEMENT = (state, newElement) => {
	if (state.elements.data) {
		state.elements.data.push(newElement)
	} else {
		state.elements.data = [];
		state.elements.data.push(newElement);
	}
}

export const SET_CURRENT_ELEMENT = (state, element) => {
	console.log("MUT: set current el", state, element)
	state.activeElement = element;
	if (element) {
		state.currentParent = element.id;
	} else {
		state.currentParent = state.currentSpace;
	}
}

export const DELETE_ELEMENT = (state, id) => {
	console.log("MUTATION DELETE ELEMENT", id, _.findIndex(state.elements.data, {
		id: id
	}));
	state.elements.data.splice(_.findIndex(state.elements.data, {
		id: id
	}), 1)
}

export const UPDATE_ELEMENT = (state, element) => {
	console.log("MUTATION UPDATE ELEMENT", element.id, _.findIndex(state.elements.data, {
		id: element.id
	}));
	state.elements.data[_.findIndex(state.elements.data, {
		id: element.id
	})] = element;
}

export const RESET_NEW_ELEMENT = (state) => {
	console.log("resetting Element");
	state.newElement = {};
}

export const SET_ELEMENTS = (state, elements) => {
	console.log("setting elements")
	if (elements.data.length) {
		state.elements = elements;
	} else {
		state.elements = [];
	}
}

// Spaces
export const DELETE_SPACE = (state, id) => {
	console.log("MUTATION DELETE SPACE", id, _.findIndex(state.spaces.data, {
		id: id
	}));
	state.spaces.data.splice(_.findIndex(state.spaces.data, {
		id: id
	}), 1)
}

export const SET_SPACES = (state, spaces) => {
	console.log("setting spaces")
	state.spaces = spaces;
}

export const ADD_SPACE = (state, newspace) => {
	state.spaces.push(newspace);
}

export const SET_SPACE = (state, space) => {
	console.log("MUTATION: setting Space", space);
	// reset active statuses
	// state.spaces = s.spaces;
	if (space) {
		state.currentSpace = space;
		state.currentParent = space.id;
	} else {
		state.currentSpace = false;
		state.currentParent = 0;
	}
}

export const UPDATE_SPACE = (state, space) => {
	state.currentSpace = space;
	console.log("MUTATION UPDATE SPACE", space.id, _.findIndex(state.spaces.data, { id: space.id }));
	state.spaces.data[_.findIndex(state.spaces.data, {
		id: space.id
	})] = space;
}

export const SET_SPACE_ELEMENTS = (state, elements) => {
	console.log("setting Space elements", state, elements);
	if (elements) {
		state.currentSpaceElements = elements;
	} else {
		state.currentSpaceElements = [];
	}
}

// Element Types

export const ADD_ATOM = (state) => {
	console.log("state", state)
		//state.newElement.atoms.push(atom);
}

export const ADD_AREA = (state) => {
	const newArea = {
		rowId: state.newElementType.inputform.areas.length + 1,
		sort: state.newElementType.inputform.areas.length + 1,
		atoms: []
	};
	state.newElementType.inputform.areas.push(newArea);
}

export const SET_CURRENT_ATOM = (state, atom) => {
	console.log("set current", state, atom)
	state.activeAtom = atom;
}
export const SORT_ATOMS = (state, area) => {
	let areaToUpdate = _.find(state.newElementType.inputform.areas, function(o) {
		return o.id == area.id;
	});
	areaToUpdate = area;
}
export const REMOVE_ATOM = (state, areaindex, atomindex) => {
	//state.newElement.rowsatoms.splice(index, 1)
}

export const DELETE_ELEMENT_TYPE = (state, id) => {
	console.log("MUTATION DELETE ELEMENT TYPE", id, _.findIndex(state.elementTypes.data, {
		id
	}));
	state.elementTypes.data.splice(_.findIndex(state.elementTypes.data, {
		id
	}), 1)
}

export const SAVE_ELEMENT_TYPE = (state, updatedElement) => {
	console.log("MUTATION SAVE", updatedElement);
	// already existing element
	if (updatedElement._rev) {
		var index = _.indexOf(state.elementTypes, _.find(state.elementTypes, {
			id: updatedElement._id
		}));
		console.log("MUTATION SAVE 2", index, state.elementTypes);
		state.elementTypes[index].doc = updatedElement;
	}
	state.activeAtom = {};
}


export const NEW_ELEMENT_TYPE = (state, newElementType) => {
	console.log("edit start", state, newElementType);
	state.newElementType = newElementType;
}

export const SET_ELEMENT_TYPES = (state, elements) => {
	console.log("setting element types")
	state.elementTypes = elements;
}

export const RESET_NEW_ELEMENT_TYPE = (state) => {
	console.log("resetting Element types");
	state.newElementType = {};
	state.activeAtom = {};
}


// WEBPACK FOOTER //
// ./src/store/vuex/mutations.js